import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UiBsPrePixModule } from '@wlp/ui-bs-pre-pix'
import { ModalService } from 'src/app/core/shared/services/modal.service';
import { PixStoreModule } from 'src/app/core/store/pix/pix.store.module';
import { InterceptService } from '../../../../../../core/intercept/intercept.service';
import { KeyTransactionPageModule } from './key-transaction/key-transaction.module';
import { ManageKeysPageModule } from './manage-keys/manage-keys.module';
import { PixRoutingModule } from './pix-routing.module';
import { PortabilityKeysPageModule } from './portability-keys/portability-keys.module';
import { PreRegisterModule } from './pre-register/pre-register.module';
import { PrepareTransactionPageModule } from './prepare-transaction/prepare-transaction.module';
import { PixRegisterKeyModule } from './register-key/register-key-pix.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PixRoutingModule,
    PreRegisterModule,
    UiBsPrePixModule,
    PixStoreModule,
    ManageKeysPageModule,
    PixRegisterKeyModule,
    PortabilityKeysPageModule,
    PrepareTransactionPageModule,
    KeyTransactionPageModule,
    AngularSvgIconModule
  ],
  providers: [
    InterceptService,
    ModalService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ],
})
export class PixModule { }
